<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">{{ $t("auto.systemFeature") }}</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.ticketReceivingLimit") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.ticketReceivingLimit" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.readyContentsLimit") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.readyContentsLimit" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.departmentLimit") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.departmentLimit" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.roleLimit") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.roleLimit" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.maxDiskSize") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.maxDiskSize" />
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.freeAiToken") }}</div>
                <div class="feature-input">
                    <a-input class="plan-input" :min="0" type="number" v-model="featureForm.freeAIToken" />
                </div>
            </div>
                <div class="feature-input">
                    <a-select v-model="featureForm.support" style="width: 100%">
                        <a-select-option value="basic-support">{{ $t("auto.basicSupport") }}</a-select-option>
                        <a-select-option value="7-24-support">{{ $t("auto.twentyFourSevenSupport") }}</a-select-option>
                    </a-select>
                </div>
            </div>
            <div class="feature-item">
                <div class="feature-label">{{ $t("auto.otherFeatures") }}</div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.softwareSupport">{{ $t("auto.softwareSupport") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.dedicatedCustomerSupport">{{ $t("auto.dedicatedCustomerSupport") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportWhatsappBusinessSetup">{{ $t("auto.whatsappBusinessSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportFacebookSetup">{{ $t("auto.facebookSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportInstagramSetup">{{ $t("auto.instagramSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportChatbotSetup">{{ $t("auto.chatbotSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportAISetup">{{ $t("auto.aiSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportAutomationSetup">{{ $t("auto.automationSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportSpecialPanelTraining">{{ $t("auto.specialPanelTraining") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportConsultancy">{{ $t("auto.consultancy") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportIntegrationSetup">{{ $t("auto.integrationSetup") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.supportStrategyPlanning">{{ $t("auto.strategyPlanning") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.readyContentsImage">{{ $t("auto.readyContentImageAdd") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.chatAndNotification">{{ $t("auto.chatAndNotification") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.chatBalloonCustomization">{{ $t("auto.chatBalloonCustomization") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.removeSupsisLogo">{{ $t("auto.removeSupsisLogo") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.databaseConnection">{{ $t("auto.databaseConnection") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.singlePanelAccess">{{ $t("auto.singlePanelAccess") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.ticketSystem">{{ $t("auto.ticketSystem") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.visitorStartChat">{{ $t("auto.visitorStartChat") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.chatbotEntegration">{{ $t("auto.chatbotIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.teamChatEntegration">{{ $t("auto.teamChatIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.whatsappEntegration">{{ $t("auto.whatsappIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.instagramEntegration">{{ $t("auto.instagramIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.messengerEntegration">{{ $t("auto.messengerIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.telegramEntegration">{{ $t("auto.telegramIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.mailEntegration">{{ $t("auto.mailIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.smsEntegration">{{ $t("auto.smsIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.webhookEntegration">{{ $t("auto.webhookIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.calenderEntegration">{{ $t("auto.calendarIntegration") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.calendarWebFeature">{{ $t("auto.calendarWebFeature") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.taskManagementEntegration">{{ $t("auto.taskManagement") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.dataProtect">{{ $t("auto.dataSecurity") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.accessAllAgent">{{ $t("auto.accessForAllAgents") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.readyContents">{{ $t("auto.readyContents") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.allEntegrations">{{ $t("auto.allIntegrations") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.permissionControl">{{ $t("auto.permissionFeatures") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.autoRezervation">{{ $t("auto.autoReservation") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.flexibleBilling">{{ $t("auto.flexibleBilling") }}</a-checkbox>
                    <a-checkbox v-model="featureForm.accessControl">{{ $t("auto.accessControl") }}</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems, Features } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            chatAndNotification: false,
            chatBalloonCustomization: false,
            removeSupsisLogo: false,
            databaseConnection: false,
            singlePanelAccess: false,
            ticketSystem: false,
            chatbotEntegration: false,
            teamChatEntegration: false,
            whatsappEntegration: false,
            instagramEntegration: false,
            messengerEntegration: false,
            telegramEntegration: false,
            accessAllAgent: false,
            visitorStartChat: false,
            dataProtect: false,
            readyContents: false,
            mailEntegration: false,
            smsEntegration: false,
            webhookEntegration: false,
            calendarWebFeature: false,
            allEntegrations: false,
            calenderEntegration: false,
            taskManagementEntegration: false,
            permissionControl: false,
            autoRezervation: false,
            flexibleBilling: false,
            readyContentsImage: false,
            accessControl: false,
            maxDiskSize: 0,
            freeAIToken: 0,
            ticketReceivingLimit: 0,
            readyContentsLimit: 0,
            departmentLimit: 0,
            roleLimit: 0,
            crmContactLimit: 0,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.SYSTEM);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.SYSTEM, ...this.featureForm };
                response[Features.SYSTEM.MAX_DISK_SIZE] = +v.maxDiskSize || 0;
                response[Features.SYSTEM.FREE_AI_TOKEN] = +v.freeAIToken || 0;
                response[Features.SYSTEM.TICKET_RECEIVING_LIMIT] = +v.ticketReceivingLimit || 0;
                response[Features.SYSTEM.READY_CONTENTS_LIMIT] = +v.readyContentsLimit || 0;
                response[Features.SYSTEM.DEPARTMENT_LIMIT] = +v.departmentLimit || 0;
                response[Features.SYSTEM.ROLE_LIMIT] = +v.roleLimit || 0;

                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.SYSTEM);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
